/**
 * This file contains different mock responses to mimic different scenarios. Toggle between them by commenting out all but one.
 */
/* eslint-disable import/prefer-default-export */

// Bank account sample response
// export const PaymentDetails = {
//   "premiumPaymentMethod": {
//     "collectionMethod": "DD",
//     "policyCrn": "15012644",
//     "frequency": "fortnightly",
//     "paymentStartDate": "2023-02-14"
//   },
//   "premiumPaymentAccount": {
//     "id": '148525',
//     "accountType": "B",
//     "accountHolderName": "Elaine Benes",
//     "accountNumberOrToken": "123123",
//     "bsb": "062-132",
//     "maskedCreditCardNumber": null,
//     "expiryDate": null,
//     "previousCreditCardToken": null
//   },
//   "claimsAccount": {
//     "id": '148525',
//     "accountType": "B",
//     "accountHolderName": "Elaine Benes",
//     "accountNumberOrToken": "123123",
//     "bsb": "062-132"
//   }
// };

// Sample response for members other than PH (with PH's claims account)
export const PaymentDetails = {
  oldPremiumAmount: 0.0,
  newPremiumAmount: 0.0,
  nextContributionDate: '2023-09-09',
  lastContributionDate: '2023-08-09',
  premiumPaymentMethod: {
    collectionMethod: 'DD',
    policyCrn: '15012644',
    frequency: 'fortnightly',
    paymentStartDate: '2023-02-14',
  },
  premiumPaymentAccount: {
    id: '148525',
    accountType: 'B',
    accountHolderName: 'Elaine Benes',
    accountNumberOrToken: '123123',
    bsb: '062-132',
    maskedCreditCardNumber: null,
    expiryDate: null,
    previousCreditCardToken: null,
  },
  claimsAccount: {
    id: '148525',
    accountType: 'B',
    accountHolderName: 'Elaine Benes',
    accountNumberOrToken: '123123',
    bsb: '062-132',
  },
  mainPolicyHolderClaimsAccount: {
    id: '1234',
    accountType: 'B',
    accountHolderName: "Policyholder's claims account",
    accountNumberOrToken: '987654321',
    bsb: '999-654',
  },
};

// Sample response for members other than PH (with PH's claims account) (DoA fail)
// export const PaymentDetails = {
//   "premiumPaymentMethod": {
//     "collectionMethod": "DD",
//     "policyCrn": "15012644",
//     "frequency": "fortnightly",
//     "paymentStartDate": "2023-02-14"
//   },
//   "premiumPaymentAccount": {
//     "id": '148525',
//     "accountType": "B",
//     "accountHolderName": "Elaine Benes",
//     "accountNumberOrToken": "123123",
//     "bsb": "062132",
//     "maskedCreditCardNumber": null,
//     "expiryDate": null,
//     "previousCreditCardToken": null
//   },
//   "claimsAccount": {
//     "id": '148525',
//     "accountType": "B",
//     "accountHolderName": "Elaine Benes",
//     "accountNumberOrToken": "123123",
//     "bsb": "062132"
//   },
//   "mainPolicyHolderClaimsAccount": {
//     "errorCode": 403,
//     "errorMessage": "DOA check failed. Access Denied"
//   }
// };

// Sample response for members other than PH (with PH's claims account) (DoA fail)
// export const PaymentDetails = {
//   "premiumPaymentMethod": {
//     "collectionMethod": "DD",
//     "policyCrn": "15012644",
//     "frequency": "fortnightly",
//     "paymentStartDate": "2023-02-14"
//   },
//   "premiumPaymentAccount": {
//     "id": '148525',
//     "accountType": "B",
//     "accountHolderName": "Elaine Benes",
//     "accountNumberOrToken": "123123",
//     "bsb": "062132",
//     "maskedCreditCardNumber": null,
//     "expiryDate": null,
//     "previousCreditCardToken": null
//   },
//   "claimsAccount": {
//     "id": '148525',
//     "accountType": "B",
//     "accountHolderName": "Elaine Benes",
//     "accountNumberOrToken": "123123",
//     "bsb": "062132"
//   },
//   "mainPolicyHolderClaimsAccount": {
//     "errorCode": 403,
//     "errorMessage": "DOA check failed. Access Denied"
//   }
// };

// Credit card sample response
// export const PaymentDetails = {
//   "premiumPaymentMethod": {
//     "collectionMethod": "DD",
//     "policyCrn": "16481913",
//     "frequency": "monthly",
//     "paymentStartDate": "2023-07-19"
//   },
//   "premiumPaymentAccount": {
//     "id": '697765',
//     "accountType": "C",
//     "accountHolderName": "card",
//     "accountNumberOrToken": "9380467660368186",
//     "bsb": null,
//     "maskedCreditCardNumber": "403000******1234",
//     "expiryDate": "2029-08-31",
//     "previousCreditCardToken": null
//   },
//   "claimsAccount": {
//     "id": '697766',
//     "accountType": "B",
//     "accountHolderName": "bank",
//     "accountNumberOrToken": "12341234",
//     "bsb": "313-000"
//   }
// };

// Invoice sample response
// export const PaymentDetails = {
//   premiumPaymentMethod: {
//     collectionMethod: 'BILL', // Possible values: ["DD", "BILL"]
//     policyCrn: '12345A',
//     frequency: 'annual', // Possible values: ["annual", "semi-annual", "quarterly", "monthly", "fortnightly"]
//     paymentStartDate: '2022-07-30',
//   },
//   premiumPaymentAccount: null,
//   claimsAccount: {
//     id: '5467',
//     accountType: 'B',
//     accountHolderName: 'Elaine Benes',
//     accountNumberOrToken: '0000 0000',
//     bsb: '000-000',
//   },
// };

// Invoice sample response #2
// export const PaymentDetails = {
//   "premiumPaymentMethod": {
//     "collectionMethod": "BILL",
//     "policyCrn": "16645558",
//     "frequency": "quarterly",
//     "paymentStartDate": "2023-08-18"
//   },
//   "premiumPaymentAccount": null,
//   "claimsAccount": {
//     "id": '730405',
//     "accountType": "B",
//     "accountHolderName": "Bank",
//     "accountNumberOrToken": "12838383",
//     "bsb": "313-000"
//   }
// };
